import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { PlatformInfoService } from '@tgx/shared/services';

/**
 * Guard that blocks access to the application from mobile devices.
 * If a mobile device is detected, redirects to the /mobile page.
 * If a desktop device tries to access /mobile, redirects to /dashboard.
 * This guard should be applied at the root level to ensure it runs before any other guards.
 */
export const mobileDeviceGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const router = inject(Router);
  const platformInfoService = inject(PlatformInfoService);

  if (!platformInfoService.isBrowser()) {
    return true;
  }

  // Check if the user agent indicates a mobile device
  const ua = navigator.userAgent;
  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);

  // If trying to access /mobile from a desktop device, redirect to dashboard
  if (state.url.includes('/mobile') && !isMobileDevice) {
    console.log('Desktop device trying to access mobile page, redirecting to dashboard');
    return router.createUrlTree(['/dashboard']);
  }

  // If already on the mobile page and is a mobile device, allow access
  if (state.url.includes('/mobile') && isMobileDevice) {
    return true;
  }

  // If mobile device tries to access any other page, redirect to mobile
  if (isMobileDevice) {
    console.log('Mobile device detected by guard, redirecting to mobile view');
    return router.createUrlTree(['/mobile']);
  }

  return true;
};
